
import { createContext, useMemo, type ReactNode } from "react";
import {
  type Locale,
  type Messages,
  getMessages,
  translate,
} from "@/i18n";

interface LanguageContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: string) => string;
  messages: Messages;
}

export const LanguageContext = createContext<LanguageContextValue | null>(null);

const FIXED_LOCALE: Locale = "ko";

export function LanguageProvider({ children }: { children: ReactNode }) {
  const value = useMemo<LanguageContextValue>(
    () => ({
      locale: FIXED_LOCALE,
      setLocale: () => {},
      t: (key: string) => translate(FIXED_LOCALE, key),
      messages: getMessages(FIXED_LOCALE),
    }),
    [],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}
